import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'src/app/helpers/helper.service';
import { SystemUser } from 'src/app/shared/Models/SystemUser';
import { LanguageService } from 'src/app/translation/Services/language.service';
import { environment } from 'src/environments/environment';
import { UsersService } from '../../Services/users.service';
import { AuthenticationService } from 'src/app/shared/Services/authentication.service';

@Component({
  selector: 'app-account-setting',
  templateUrl: './account-setting.component.html',
  styleUrls: ['./account-setting.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountSettingComponent implements OnInit {
    public classicBox;
    public lastValue = <any>{};
    public enableSave = true;
    form = new UntypedFormGroup({});
    model: any = {};
    public systemUser: SystemUser = new SystemUser();
    public isEdit = false;
    public languages = [];
    public showAuth = false;
    options: FormlyFormOptions = {};
    @ViewChild('classicForm', {static: false}) child;
    @ViewChild('activateTwoFactorAuthModal', {static: false}) activateTwoFactorAuthModal;
    @ViewChild('successfullyActivateTwoFactorModal', {static: false}) successfullyActivateTwoFactorModal;
    @ViewChild('failedActivateTwoFactorModal', {static: false}) failedActivateTwoFactorModal;
    public twoFactorAuthForm = new UntypedFormGroup({});
    public lastValueOfTwoFactorAuth: any;
    public twoFactorAuthFields;
    public twoFactorAuthOptions: FormlyFormOptions = {};
    public qrCodeUrl: string = '';
    public twoFactorCodesIsLoading: boolean = false;
    public isGoogleAuthenticatorEnabled: boolean = false;

    constructor(
      public languageService: LanguageService,
      public helper: Helper,
      private translate: TranslateService,
      private userService: UsersService,
      private auth: AuthenticationService
    ) {
    }


    ngOnInit() {
      new Promise((resolve) => {
        this.isEdit = true;
        this.userService.getCurrentUser().subscribe((user) => {
          resolve(user);
        });
      }).then((user: any) => {
        if (this.isEdit) {
          this.lastValue = {user: user, auth: user};
          this.lastValue.user.language = this.lastValue.user.language.id;
          if (user && user.isGoogleAuthenticatorEnabled === true) {
            this.isGoogleAuthenticatorEnabled = true;
          }
        }
      }).then(() => {
        this.languageService.list().subscribe(response => {
          response.languages.map((value) => {
            this.languages.push({
              label: value.name,
              value: value.id
            });
          });

          this.initiateClassicBox();
        });
      });
    }

    private initiateClassicBox() {
      this.classicBox = <FormlyFieldConfig>[
        {
          fieldGroupClassName: 'row',
          key: 'user',
          fieldGroup: [
            {
              className: 'col-12 col-md-3 ',
              type: 'input',
              key: 'firstName',
              templateOptions: {
                label: this.translate.instant('doctrine.user.firstName'),
                required: true,
                pattern: '[a-zA-Z _-]+',
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
            {
              className: 'col-12 col-md-3',
              type: 'input',
              key: 'lastName',
              templateOptions: {
                label: this.translate.instant('doctrine.user.lastName'),
                required: true,
                pattern: '[a-zA-Z _-]+',
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
          ],
        },
        {
          className: 'section-label',
          template: '<div class="m-b-10"><strong>' + this.translate.instant('doctrine.user.address') + '</strong></div><hr />',
        },
        {
          fieldGroupClassName: 'row',
          key: 'user',
          fieldGroup: [
            {
              className: 'col-12 col-md-3 ',
              type: 'input',
              key: 'email',
              templateOptions: {
                label: this.translate.instant('doctrine.user.email'),
                maxLength: environment.maxStringLength,
                pattern: environment.emailPattern,
              },
              validation: {
                messages: {
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
            {
              className: 'col-12 col-md-3',
              type: 'input',
              key: 'phone',
              templateOptions: {
                label: this.translate.instant('doctrine.user.phone'),
                required: true,
                pattern: '[0-9]+',
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required')
                },
              },
            },
          ],
        },
        {
          className: 'section-label',
          template: '<div class="m-b-10"><strong>' + this.translate.instant('doctrine.user.language') + ' </strong></div><hr />',
        },
        {
          fieldGroupClassName: 'row',
          key: 'user',
          fieldGroup: [
            {
              key: 'language',
              type: 'ng-select',
              className: 'col-12 col-md-3 ',
              templateOptions: {
                label: this.translate.instant('doctrine.attributes.language'),
                options: this.languages,
                required: true,
              },
            },
          ],
        },
        {
          className: 'section-label',
          template: '<div class="m-b-10 mt-3"><strong>' + this.translate.instant('doctrine.user.login_credential') + ' </strong></div><hr />',
        },
        {
          fieldGroupClassName: 'row',
          key: 'auth',
          fieldGroup: [
            {
              className: 'col-12 col-md-3 ',
              type: 'input',
              key: 'username',
              pattern: '[a-zA-Z _-]+',
              templateOptions: {
                label: this.translate.instant('doctrine.user.username'),
                required: true,
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  required: this.translate.instant('errors.required'),
                  pattern: this.translate.instant('errors.invalid'),
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
            {
              className: 'mx-2 col-md-auto px-0 changePassword-button d-flex align-items-center',
              type: 'button',
              hideExpression: (model) => !this.isEdit,
              templateOptions: {
                text: this.translate.instant('admin.dealer.account.change_password'),
                btnType: 'primary',
                onClick: ($event) => {
                  this.showAuth = !this.showAuth;
                },
              },
            },
            {
              className: 'mx-2 col-md-auto px-0 activate2fa-button d-flex align-items-center',
              type: 'button',
              templateOptions: {
                text: this.translate.instant('admin.backoffice.account.2factor_authentication'),
                btnType: 'primary',
                onClick: () => {
                  this.onTwoFactorAuthClick();
                },
              },
            }
          ],
        },
        {
          fieldGroupClassName: 'row',
          key: 'auth',
          validators: {
            fieldMatch: {
              expression: (control) => {
                const value = control.value;
                if (this.showAuth || !this.isEdit) {
                  return value.plainPasswordConfirm === value.plainPassword || (!value.plainPasswordConfirm && !value.plainPassword);
                }
                return true;
              },
              message: this.translate.instant('errors.passwordMatch'),
              errorPath: 'plainPasswordConfirm',
            },
          },
          fieldGroup: [
            {
              className: 'col-12 col-md-3',
              type: 'input',
              key: 'plainPassword',
              hideExpression: (model) => (!this.showAuth) && (this.isEdit),
              templateOptions: {
                label: this.translate.instant('doctrine.user.plainPassword'),
                required: () => ((!this.showAuth) && (this.isEdit)),
                type: 'password',
                minLength: environment.minPassword,
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  minLength: this.translate.instant('validators.password.length.min',
                    {limit: environment.minPassword}),
                  maxLength: this.translate.instant('validators.password.length.max',
                    {limit: environment.maxStringLength}),
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  lowerCase: this.translate.instant('validators.password.contain.lowercase'),
                  uppercase: this.translate.instant('validators.password.contain.uppercase'),
                  number: this.translate.instant('validators.password.contain.number'),
                  special: this.translate.instant('validators.password.contain.special'),
                },
              },
              validators:  {
                validation: ['lowerCase', 'uppercase', 'number', 'special'],
              },
            },
            {
              className: 'col-12 col-md-3',
              type: 'input',
              key: 'plainPasswordConfirm',
              hideExpression: (model) => (!this.showAuth) && (this.isEdit),
              templateOptions: {
                type: 'password',
                label: this.translate.instant('doctrine.user.plainPasswordConfirm'),
              }
            }
          ]
        },
      ];
    }

    public onTwoFactorAuthClick() {
      this.twoFactorCodesIsLoading = true;
      this.activateTwoFactorAuthModal.show();
      this.userService.activateTwoFactorAuthenticate().subscribe((res) => {
        if (res && res.qrCodeUrl && res.qrCodeSecret) {
          this.qrCodeUrl = res.qrCodeUrl;
          this.lastValueOfTwoFactorAuth = {...res}
          this.twoFactorCodesIsLoading = false;
        }
      });
      this.initiateTwoFactorAuthForm();
    }

    public onQrCodeInputClick(event?: any) {
      if (event && event.target) {
        event.target.select();

        const listener = (e: ClipboardEvent) => {
          const clipboard = e.clipboardData || window['clipboardData'];
          clipboard.setData('text', event.target.value);
          e.preventDefault();
        };

        document.addEventListener('copy', listener, false);
        document.execCommand('copy');
        document.removeEventListener('copy', listener, false);

        this.helper.showNotify('',
          this.translate.instant('admin.backoffice.account.2fa.secret_copied_to_clipboard'),
          'success'
        );
      }
    }

    private initiateTwoFactorAuthForm() {
      this.twoFactorAuthFields = <FormlyFieldConfig>[
        {
          className: 'col-12',
          type: 'input',
          key: 'qrCodeSecret',
          templateOptions: {
            maxLength: environment.maxStringLength,
            click: (_field: FormlyFieldConfig, event?: any) => {
              this.onQrCodeInputClick(event);
            },
            readonly: true,
            attributes: {
              'class': 'two-factor-input w-100 py-2 px-3 rounded-lg border-2 text-center font-weight-bold',
            }
          },
        },
        {
          className: 'col-12',
          type: 'input',
          key: 'auth_code',
          templateOptions: {
            required: true,
            maxLength: 6,
            minLength: 6,
            pattern: '[0-9]+',
            placeholder: this.translate.instant('admin.backoffice.account.2fa.enterCode'),
            attributes: {
              'class': 'two-factor-input w-100 py-2 px-3 rounded-lg border-2 text-center font-weight-bold',
              'maxLength': 6,
            }
          },
          validation: {
            messages: {
              pattern: this.translate.instant('errors.invalid'),
              required: this.translate.instant('errors.required'),
            },
          },
        },
      ];
    }

    hideModal() {
      this.activateTwoFactorAuthModal.hide();
    }

    closeSuccessfulTwoFactorAuth(){
      this.successfullyActivateTwoFactorModal.hide();
    }

    closeFailedTwoFactorAuth(){
      this.failedActivateTwoFactorModal.hide();
    }

    activateTwoFactorAuth() {
      this.userService.verifyTwoFactorAuthenticate(this.lastValueOfTwoFactorAuth.auth_code).subscribe((res) => {
        this.activateTwoFactorAuthModal.hide();
        this.successfullyActivateTwoFactorModal.show();
        this.isGoogleAuthenticatorEnabled = true;
      },(error)=>{
        this.failedActivateTwoFactorModal.show();
      });
    }

    enableButton(event) {

      this.enableSave = event;
    }

    submitItem() {
      const login = JSON.parse(JSON.stringify(this.lastValue.user));
      const auth = JSON.parse(JSON.stringify(this.lastValue.auth));
      const user = Object.assign(login, auth);
      delete user.lastRequest;
      delete user.plainPasswordConfirm;
      delete user.roles;
      delete user.user;
      delete user.id;
      delete user.isAllowedPartialPaid;
      delete user.dealerPoints;
      delete user.role;
      delete user.companyPhone;
      delete user.status;
      delete user.fullName;
      delete user.isGoogleAuthenticatorEnabled;
      delete user.exactId;
      delete user.isBillingAccount;
      delete user.isPrivateAccount;
      delete user.isCustomerAccount;
      this.userService.updateCurrentUser(user).subscribe(() => {
        this.translate.use(this.auth.getLocale()).subscribe(() => {
          this.initiateClassicBox();
          this.helper.popMessageDialog(
            this.translate.instant('global.success_message.title'),
            this.translate.instant('admin.account.success.message'),
            'success',
            false
          );
        });
      });
    }
}
